document.addEventListener('DOMContentLoaded', function () {
  // Product page swiper customisations
  if(document.querySelector('.product-main__gallery')) {
    const swiperEl = document.querySelector('.product-main__gallery');
    const swiperInstance = swiperEl.swiper;

    // Remove slash from desktop pagination
    let baseConfig = JSON.parse(swiperEl.dataset.swiper);
    baseConfig.pagination.renderFraction = function (currentClass, totalClass) {
      return `<span class="${currentClass}"></span><span class="${totalClass}"></span>`;
    };

    new window.Moonbase.Swiper(swiperEl, baseConfig);

    // Reinitialise swiper on resize and orientation change
    window.addEventListener('resize', function (e) {
      new window.Moonbase.Swiper(swiperEl, baseConfig);
    });

    window.addEventListener('orientationchange', function (e) {
      new window.Moonbase.Swiper(swiperEl, baseConfig);
    });

    // Scroll between slides on desktop
    if (swiperInstance && swiperInstance.slides.length > 1) {
      let lastScrollY = window.scrollY;
      let scrollLocked = false;

      const lockScroll = () => {
        document.body.classList.add('scroll-locked');
        window.scrollTo(0, 0);
        scrollLocked = true;
      };

      const unlockScroll = () => {
        document.body.classList.remove('scroll-locked');
        scrollLocked = false;
      };

      const onScroll = () => {
        if (!window.matchMedia('(min-width: 1024px)').matches) return;

        const currentScroll = window.scrollY;
        const currentIndex = swiperInstance.activeIndex;
        const maxIndex = swiperInstance.slides.length - 1;

        // Scroll down to move to next slide
        if (currentScroll > lastScrollY && currentIndex < maxIndex) {
          lockScroll();
          swiperInstance.slideTo(currentIndex + 1);
        }

        lastScrollY = currentScroll;
      };

      const onWheel = (e) => {
        if (!window.matchMedia('(min-width: 1024px)').matches) return;

        const currentScroll = window.scrollY;
        const currentIndex = swiperInstance.activeIndex;

        // Scroll up to move to previous slide
        if (currentScroll <= 0 && e.deltaY < 0 && currentIndex > 0) {
          lockScroll();
          swiperInstance.slideTo(currentIndex - 1);
        }

        // While locked, block wheel scroll
        if (scrollLocked) {
          e.preventDefault();
        }
      };

      swiperInstance.on('transitionEnd', () => {
        unlockScroll();
        window.scrollTo(0, 0);
      });

      window.addEventListener('scroll', onScroll);
      window.addEventListener('wheel', onWheel, { passive: false });
    }

  }

  const mainButton = document.querySelector('.product-form__submit');
  const floatingButton = document.querySelector('.floating-add-to-cart-button');
  let isMainButtonVisible = true;

  if (window.innerWidth < 1024 && mainButton && floatingButton) {
    // Use IntersectionObserver to track visibility
    const observer = new IntersectionObserver(
      ([entry]) => {
        isMainButtonVisible = entry.isIntersecting;
        updateFloatingButtonVisibility();
      },
      { threshold: 0.1 }
    );

    observer.observe(mainButton);

    // Watch scroll position too
    window.addEventListener('scroll', updateFloatingButtonVisibility);

    // Click handler
    floatingButton.addEventListener('click', (e) => {
      e.preventDefault();
      mainButton.click();
    });
  }

  // Update visibility based on scroll position
  function updateFloatingButtonVisibility() {
    const rect = mainButton.getBoundingClientRect();
    const isScrolledBelowMainButton = rect.bottom < 0;

    if (!isMainButtonVisible && isScrolledBelowMainButton) {
      floatingButton.classList.remove('hidden');
    } else {
      floatingButton.classList.add('hidden');
    }
  }
});